import { useContext } from 'react';
import { context } from '../../context';

const useHandleSortBy = () => {
  const { dispatch, data, queryParam } = useContext(context);

  const handleSortBy = ({ sortBy }: { sortBy: string[] }) => {
    const changeFilter = JSON.stringify(queryParam.sortBy) !== JSON.stringify(sortBy);

    if (changeFilter) {
      const filtered = async () => {
        const response = await data?.fetchMore({
          variables: {
            ...queryParam,
            sortBy,
          },
        });

        dispatch({ type: 'SET_FETCH_MORE_LOADING', data: false });
        dispatch({
          type: 'SET_DATA',
          data: {
            reviews: response.data.reviews.result,
            total: response.data.reviews.meta.total,
            comments: response?.data?.reviews?.meta?.total,
          },
        });
      };

      dispatch({ type: 'SET_SORTBY', data: sortBy });
      dispatch({ type: 'SET_FETCH_MORE_LOADING', data: true });
      filtered();
    }
  };

  return { handleSortBy };
};

export default useHandleSortBy;
export { useHandleSortBy };
